class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  async #init() {
    if (!Shopify.recentlyViewed) {
      return;
    }

    const products = await Shopify.recentlyViewed.getRecentlyViewed();
    if (!products.length) {
      return;
    }

    new Vue({
      el: this,
      data: {
        products,
      },
      template: `
        <div class="recently-viewed section">
          <h2 class="section-title">Recently Viewed</h2>
          <div class="recently-viewed__slider">
            <div class="swiper-container" ref="slider">
              <div class="swiper-wrapper">
                <template v-for="product in products">
                  <div class="swiper-slide" :key="product.id">
                    <div class="recently-viewed__product">
                      <a :href="'/products/' + product.handle" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></a>

                      <div class="recently-viewed__product-img">
                        <img 
                          :srcset="$options.filters.formatImage(product.variants[0].featured_image, '150x150')" 
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                          loading="lazy"
                          alt=""
                          width="150"
                          height="150"
                        >
                      </div>
                      
                      <div class="recently-viewed__product-information">
                        <p class="recently-viewed__product-title">
                          {{ product.variants[0].full_title }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
  
            <div class="slider-button-prev" ref="sliderBtnPrev">
              <div class="icon-arrow circle icon-arrow-prev">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                  <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
                  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
                  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
                  C255,161.018,253.42,157.202,250.606,154.389z"/>
                </svg>
              </div>
            </div>
            <div class="slider-button-next" ref="sliderBtnNext">
             <div class="icon-arrow circle icon-arrow-next">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve">
                  <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
                  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
                  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
                  C255,161.018,253.42,157.202,250.606,154.389z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      `,

      async mounted() {
        this.initSlider();
      },

      methods: {
        initSlider() {
          new Swiper(this.$refs.slider, {
            speed: 500,
            slidesPerView: 2.9,
            spaceBetween: 10,
            observer: true,
            breakpoints: {
              750: {
                slidesPerView: 4.9,
              },
              990: {
                slidesPerView: window.Shopify.template === 'product' ? 4.5 : 6,
              },
            },
            navigation: {
              nextEl: this.$refs.sliderBtnNext,
              prevEl: this.$refs.sliderBtnPrev,
            },
          });
        },
      },

      filters: {
        formatImage(src, size, crop) {
          return formatImage(src, size, crop);
        },
      },
    });
  }
}

customElements.define('recently-viewed', RecentlyViewed);
